/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whether this server is required or optional.
 */
export const PluginServerPolicy = {
  Required: "required",
  Optional: "optional",
} as const;
/**
 * Whether this server is required or optional.
 */
export type PluginServerPolicy = ClosedEnum<typeof PluginServerPolicy>;

export type PluginServer = {
  createdAt: Date;
  /**
   * Display name shown in generated plugin config.
   */
  displayName: string;
  /**
   * Unique plugin server identifier.
   */
  id: string;
  /**
   * Speakeasy MCP server ID. A hosted MCP server with a live canonical MCP server sets toolset_id and mcp_server_id to the same id; otherwise exactly one backend ID is set.
   */
  mcpServerId?: string | undefined;
  /**
   * MCP gateway ID. When set, no other backend ID is set.
   */
  metaMcpServerId?: string | undefined;
  /**
   * Whether this server is required or optional.
   */
  policy: PluginServerPolicy;
  /**
   * Ordering within the plugin.
   */
  sortOrder: number;
  /**
   * Speakeasy toolset ID. A hosted MCP server with a live canonical MCP server sets toolset_id and mcp_server_id to the same id; otherwise exactly one backend ID is set.
   */
  toolsetId?: string | undefined;
};

/** @internal */
export const PluginServerPolicy$inboundSchema: z.ZodMiniEnum<
  typeof PluginServerPolicy
> = z.enum(PluginServerPolicy);

/** @internal */
export const PluginServer$inboundSchema: z.ZodMiniType<PluginServer, unknown> =
  z.pipe(
    z.object({
      created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      display_name: z.string(),
      id: z.string(),
      mcp_server_id: z.optional(z.string()),
      meta_mcp_server_id: z.optional(z.string()),
      policy: PluginServerPolicy$inboundSchema,
      sort_order: z.int(),
      toolset_id: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "created_at": "createdAt",
        "display_name": "displayName",
        "mcp_server_id": "mcpServerId",
        "meta_mcp_server_id": "metaMcpServerId",
        "sort_order": "sortOrder",
        "toolset_id": "toolsetId",
      });
    }),
  );

export function pluginServerFromJSON(
  jsonString: string,
): SafeParseResult<PluginServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PluginServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PluginServer' from JSON`,
  );
}
